<script>


export default {

    name: "EditProfile",
    data() {
        return {
            user: {...this.$auth.user},
            password: '',
            errors: {},
            loading: false,
            showTax: import.meta.env.VITE_SHOW_TAX_CLIENT === 'true',
            showAutoSettlement: import.meta.env.VITE_SHOW_AUTOPROCESS_CLIENT === 'true',
        }
    },
    methods: {
        submit() {
            this.errors = {};
            this.loading = true;
            const data = {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                phone_number: this.user.phone_number,
                pesel: this.user.pesel,
                bank_account_number: this.user.bank_account_number,
                tax_bank_account_number: this.user.company.tax_bank_account_number,
                auto_settlement: this.user.auto_settlement,
                tax_active: this.user.tax_active,
                tax_rate: this.user.tax_rate,
                company_name: this.user.company.name,
                company_nip: this.user.company.nip,
                company_city: this.user.company.city,
                company_address: this.user.company.address,
                password: this.password
            };
            axios.post('/profile', data)
                .then(async () => {
                    await this.$auth.fetchUser();
                    this.$toast.success(this.$t('messages.updated_successfully'))
                }).catch((data) => {
                    this.errors = data.response?.data?.errors || {};
                }).finally(() => {
                    this.loading = false;
                });
        }
    },
    mounted() {
    }
}

</script>
<template>
    <div class="edit-profile">
        <form @submit.prevent="submit">

            <b-field :label="$t('users.fields.first_name.name')" custom-class="mb-3"
                     label-for="first_name"
                     v-if="$auth.isEmployee() || $auth.isTrainer()"
                     :type="errors.first_name ? 'is-danger' : null"
                     :message="errors.first_name ? errors.first_name[0] : null">
                <b-input
                    id="first_name"
                    required
                    v-model="user.first_name"
                    icon="account"
                ></b-input>
            </b-field>

            <b-field :label="$t('users.fields.last_name.name')" custom-class="mb-3"
                     label-for="last_name"
                     v-if="$auth.isEmployee() ||$auth.isTrainer()"
                     :type="errors.last_name ? 'is-danger' : null"
                     :message="errors.last_name ? errors.last_name[0] : null">
                <b-input
                    id="last_name"
                    required
                    v-model="user.last_name"
                    icon="account"
                ></b-input>
            </b-field>

            <b-field :label="$t('users.fields.email.name')" custom-class="mb-3"
                     label-for="email"
                     :type="errors.email ? 'is-danger' : null"
                     :message="errors.email ? errors.email[0] : null">
                <b-input
                    required
                    type="email"
                    id="email"
                    v-model="user.email"
                    icon="at"
                ></b-input>
            </b-field>

            <b-field :label="$t('users.fields.phone_number.name')" custom-class="mb-3"
                     label-for="phone"
                     v-if="$auth.isEmployee() ||$auth.isTrainer()"
                     :type="errors.phone_number ? 'is-danger' : null"
                     :message="errors.phone_number ? errors.phone_number[0] : null">
                <b-input
                    id="phone"
                    v-model="user.phone_number"
                    icon="phone"
                ></b-input>
            </b-field>

            <b-field :label="$t('users.fields.pesel.name')" custom-class="mb-3"
                     label-for="pesel"
                     v-if="$auth.isEmployee() ||$auth.isTrainer()"
                     :type="errors.pesel ? 'is-danger' : null"
                     :message="errors.pesel ? errors.pesel[0] : null">
                <b-input
                    id="pesel"
                    maxlength="11"
                    v-model="user.pesel"
                    icon="card-account-details-outline"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.name.name')" custom-class="mb-3"
                     label-for="company_name"
                     v-if="$auth.isEmployer()"
                     :type="errors.company_name ? 'is-danger' : null"
                     :message="errors.company_name ? errors.company_name[0] : null">
                <b-input :disabled="!$auth.isEmployer()"
                         id="company_name"
                         v-model="user.company.name"
                         icon="domain"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.name.name')" custom-class="mb-3"
                     label-for="company_name"
                     v-if="$auth.isEmployee() || $auth.isTrainer()"
                     :type="errors.company_name ? 'is-danger' : null"
                     :message="errors.company_name ? errors.company_name[0] : null">
                <div v-for="company in $auth.user.companies">
                    {{ company.name}}
                </div>
            </b-field>

            <b-field :label="$t('companies.fields.nip.name')" custom-class="mb-3"
                     label-for="nip"
                     v-if="$auth.isEmployer()"
                     :type="errors.nip ? 'is-danger' : null"
                     :message="errors.nip ? errors.nip[0] : null">
                <b-input required
                         id="nip"
                         v-model="user.company.nip"
                         icon="card-account-details-outline"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.city.name')" custom-class="mb-3"
                     label-for="city"
                     v-if="$auth.isEmployer()"
                     :type="errors.city ? 'is-danger' : null"
                     :message="errors.city ? errors.city[0] : null">
                <b-input required
                         id="city"
                         v-model="user.company.city"
                         icon="city"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.address.name')" custom-class="mb-3"
                     label-for="address"
                     v-if="$auth.isEmployer()"
                     :type="errors.address ? 'is-danger' : null"
                     :message="errors.address ? errors.address[0] : null">
                <b-input required
                         id="address"
                         v-model="user.company.address"
                         icon="map-marker"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.bank_account_number.name')" custom-class="mb-3"
                     label-for="bank_account_number"
                     v-if="$auth.isEmployee() || $auth.isEmployer()"
                     :type="errors.bank_account_number ? 'is-danger' : null"
                     :message="errors.bank_account_number ? errors.bank_account_number[0] : null">
                <b-input
                    id="bank_account_number"
                    v-model="user.bank_account_number"
                    icon="bank"
                ></b-input>
            </b-field>

            <b-field :label="$t('companies.fields.tax_bank_account_number.name')" custom-class="mb-3"
                     label-for="tax_bank_account_number"
                     v-if="$auth.isEmployer()"
                     :type="errors.tax_bank_account_number ? 'is-danger' : null"
                     :message="errors.tax_bank_account_number ? errors.tax_bank_account_number[0] : null">
                <b-input
                    id="tax_bank_account_number"
                    v-model="user.company.tax_bank_account_number"
                    icon="bank"
                ></b-input>
            </b-field>

            <b-field v-if="$auth.isEmployee() && this.showAutoSettlement" class="checkbox-wrapper mb-3">
                <b-checkbox v-model="user.auto_settlement"
                            input-id="auto_settlement"
                            true-value="1"
                            false-value="0">
                </b-checkbox>
                <label for="auto_settlement" class="label">{{ $t('users.fields.auto_settlement.name') }}</label>
            </b-field>

            <b-field v-if="$auth.isEmployee() && this.showTax"
                     class="checkbox-wrapper mb-3">
                <b-checkbox v-model="user.tax_active"
                            input-id="tax_active"
                            true-value="1"
                            false-value="0">
                </b-checkbox>
                <label for="tax_active" class="label">{{ $t('users.fields.tax_axtive.name') }}</label>
            </b-field>

            <b-field :label="$t('users.fields.tax_rate.name')" custom-class="mb-3"
                     v-if="$auth.isEmployee() && this.showTax"
                     label-for="tax_rate"
                     :type="errors.tax_rate ? 'is-danger' : null"
                     :message="errors.tax_rate ? errors.tax_rate[0] : null">
                <b-input
                    type="number"
                    min="0"
                    max="100"
                    :disabled="user.tax_active == 0"
                    v-model="user.tax_rate"
                    icon="percent-box-outline"
                ></b-input>
            </b-field>

            <b-field :label="$t('auth.fields.current_password.name')" custom-class="mb-3"
                     label-for="password"
                     :type="errors.password ? 'is-danger' : null"
                     :message="errors.password ? errors.password[0] : null">
                <b-input
                    autocomplete="new-password"
                    required
                    type="password"
                    v-model="password"
                    icon="lock"
                ></b-input>
            </b-field>

            <section class="mt-4">
                <button class="button is-primary" type="submit"
                        v-bind:class="{'is-loading': loading}">
                    {{ $t('actions.save') }}
                </button>
            </section>

        </form>
    </div>

</template>
